import { usePinterestVisibilityProps } from "hooks/usePinterestVisibilityProps"
import { Category, Post } from "types"
import { getBreadcrumbsUri } from "utils/getBreadcrumbsUri"
import { getCategoryByParentName } from "utils/getCategoryByParentName"
import { getOriginPage } from "utils/getOriginPage"
import { segmentTrack } from "utils/segmentAnalytics"

export const usePostData = (post: Post, category?: Category) => {
  const categoryByName = getCategoryByParentName(
    post.categories.nodes,
    category?.name
  )
  const categoryBreadcrumbs = categoryByName?.seo?.breadcrumbs
  const categoryName = categoryBreadcrumbs[1].text

  const { imageProps, pinterestButtonProps } = usePinterestVisibilityProps()

  return {
    categoryName,
    categoryUrl: getBreadcrumbsUri(categoryBreadcrumbs[1].url),
    featuredImage: post.featuredImage?.node,
    imageProps,
    pinterestButtonProps,
    trackPostView: () => {
      segmentTrack(`blog.${getOriginPage()}.view_post`, {
        category: categoryName,
      })
    },
  }
}
